import React, { useEffect, useState } from 'react';
import './About.scss';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import { Icon, LazyLoad } from '../../components/ui/index';
import htbSteps from '../../constants/htb-steps.constant';
import AboutPrescription from './step-2/AboutPrescription';
import ChooseLens from './step-1/ChooseLens';
import AboutKiosk from './step-3/AboutKiosk';
import AboutDelivery from './step-4/AboutDelivery';

const About = () => {
  const [selectStep, setSelectStep] = useState(htbSteps[0]);

  useEffect(() => {
    setSelectStep(selectStep);
  }, [selectStep]);

  const handleChange = (step: any, index: number) => {
    setSelectStep(step);
  };

  const renderStep = () => {
    switch (selectStep.label) {
      case 'Step 1':
        return <ChooseLens />;
      case 'Step 2':
        return <AboutPrescription />;
      case 'Step 3':
        return <AboutKiosk />;
      case 'Step 4': {
        return <AboutDelivery />;
      }
      default: {
        return <AboutPrescription />;
      }
    }
  };

  return (
    <>
      <Breadcrumbs path={`About VisionHub`} />
      <div className="about banner">
        <div className="wrapper">
          <div className="about-info">
            <span className="about-logo">VisionHub</span>
            <p className="about-tag">Easy. Fast. Anywhere. Anytime.</p>
          </div>
        </div>
      </div>
      <div className="intro">
        <div className="wrapper row row1 odd">
          <h2>A new way to buy glasses</h2>
          <div className="column left">
            <Icon imgPath="/images/about/visionhub-container.png"></Icon>
          </div>
          <div className="column right">
            <h3>OUR PRODUCT/OFFER</h3>
            <p>
              VisionHub is an innovative solution that brings eyecare solutions to your DOORSTEP. We
              are settling kiosks in many different areas where you will be able to buy eyeglasses
              and sunglasses fitted to your OWN prescription. After having placed your order you
              just need to wait for a few days before receiving your products in your mailbox.
            </p>
            <p>
              In addition to the KIOSK, we created a dedicated ONLINE presence so that you be able
              to consult, modify or complete your PURCHASE in order not to only have the in-store
              physical kiosks.
            </p>
            <p>
              If you ever have any QUESTIONS you can always reach our customer’s service by mail,
              phone or live CHAT or you can also come and have a talk on our SOCIAL media pages.
              We'll be more than happy to answer them.
            </p>
            <h3>OUR HISTORY</h3>
            <p>
              Started in 2014, VISIONHUB is an ambitious start-up initiative supported by a team of
              deep track record people dedicated to EXECUTION. With its PARTNERS VisionHub grows up
              fast to develop its product also as its services to propose an all-in-one TURNKEY
              solution.
            </p>
            <p>
              The development of the company relies on a line of INNOVATION and effectiveness. After
              ONLY one year of R&amp;D VisionHub is now proud to offer YOU its innovative retail
              solution that will make consumers LIFE EASIER.
            </p>
            <p>
              VisionHub’s DNA has always been DISRUPTIVE. The firm aimed to create a new way of
              THINKING in order to break the rules and bring more convenience to our customers.
            </p>
            <h3>OUR MISSION</h3>
            <p>
              VisionHub’s mission is to bring eyecare solutions where still lots of boundaries make
              solutions tricky for the local consumers.
            </p>
            <p>
              The firm’s mission is also to ensure that our service and products are the BEST IN
              CLASS and provide entire SATISFACTION to our consumers to build a trustful
              relationship.
            </p>
          </div>
        </div>
      </div>
      <div className="tabs">
        <div className="wrapper">
          <ul>
            {htbSteps.map((h, i) => (
              <li
                key={h.label}
                className={`tabs-item${h === selectStep ? ' active' : ''}`}
                onClick={() => handleChange(h, i)}
              >
                {/* <Icon imgPath={h.imagePath} className="tabs-icon"></Icon> */}
                <LazyLoad imgSrc={h.imagePath} imgAlt="Nice" />

                <p className="tabs-label">
                  <span className="bold">{`${i + 1}.`} </span> {h.description}
                </p>
                <div className="indicator">&nbsp;</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="about-steps">{renderStep()}</div>
    </>
  );
};

export default About;
